import { Star } from 'lucide-react';
import { useFavorites, matchPage } from '../../lib/favorites';

export function FavoriteStar({ pathname }) {
  const { catalog, items, toggle } = useFavorites();
  const page = matchPage(catalog, pathname);
  if (!page) return null;
  const on = items.some((i) => i.path === page.path);
  return (
    <div className="flex items-center gap-2 min-w-0" data-testid="fav-page-header">
      <span className="hidden sm:block text-sm font-semibold text-slate-700 dark:text-slate-200 truncate max-w-[260px]">{page.label}</span>
      <button type="button" onClick={() => toggle(page)} title={on ? 'Favorilerden çıkar' : 'Favorilere ekle'}
        className={`h-8 w-8 rounded-full inline-flex items-center justify-center transition-[background-color,transform] active:scale-90 ${on ? 'bg-amber-100 dark:bg-amber-900/30' : 'hover:bg-slate-100 dark:hover:bg-slate-800'}`}
        data-testid="fav-star-toggle" aria-pressed={on}>
        <Star className={`h-4 w-4 transition-colors ${on ? 'fill-amber-400 text-amber-500' : 'text-slate-400'}`} />
      </button>
    </div>
  );
}
